import styled from "styled-components";
import Alert from '@material-ui/lab/Alert';


export const BannerAlert = styled(Alert)`
   &&& {  width: 100%; }
`;

export default BannerAlert;
